import { n as o } from "./Logger-CmiOOsKC.js";
import { r as y, t as S } from "./tracebehavior-5_qSKjs6.js";
import { r as l, t as G } from "./TransformUtils-Bd2LIBHs.js";
import { t as _ } from "./TransitionManager-BD_yHXIb.js";
import { n as d } from "./bindingValues-BuN2Qy2j.js";
import { r as g } from "./AnimationUtils-Dau2PA8x.js";
import { AnimationGroup as A } from "@babylonjs/core/Animations/animationGroup.js";
var p = [
  "enter",
  "main",
  "exit"
], f = {
  enter: "EnterAnimation",
  main: "MainAnimation",
  exit: "ExitAnimation"
}, m = class {
  constructor(e, t) {
    this._access = e, this._state = t;
  }
  get src() {
    return this._access.getResolved(this._state)?.src;
  }
  get clip() {
    return this._access.getResolved(this._state)?.clip;
  }
  get speed() {
    return this._access.getResolved(this._state)?.speed ?? 1;
  }
  get delay() {
    return this._access.getResolved(this._state)?.delay ?? 0;
  }
  get isEmpty() {
    return !this.src;
  }
  setSpeed(e) {
    return this._access.setSpeed(this._state, e);
  }
  async setSrc(e, t) {
    await this._access.commitState(this._state, t ? {
      src: e,
      clip: t
    } : { src: e });
  }
  async clear() {
    this.isEmpty || await this._access.clearState(this._state);
  }
  stop() {
    this._access.stopState(this._state);
  }
  pose() {
    this._access.poseState(this._state);
  }
  play() {
    return this._access.playState(this._state);
  }
  async getClipNames() {
    const e = this.src;
    return e ? this._access.getClipNamesForSrc(e) : [];
  }
}, T = class extends S {
  static behaviorType = "AnimationSequence";
  enterGroup = null;
  mainGroup = null;
  exitGroup = null;
  _currentState = "idle";
  _enterDelayTimer = null;
  _exitDelayTimer = null;
  _exitDelayResolve = null;
  _enterEndObserver = null;
  constructor(e, t) {
    super(e, t), this.validate(this.getAuthored()), this._resolved = this._resolveAll();
  }
  validate(e) {
    const t = [];
    e.states || (e.states = {});
    for (const s of [
      "enter",
      "main",
      "exit"
    ]) {
      const i = e.states[s];
      i && (i.src && typeof i.src != "string" && t.push({
        field: `states.${s}.src`,
        message: "Animation source must be a string",
        code: "INVALID_SRC"
      }), i.clip && typeof i.clip != "string" && t.push({
        field: `states.${s}.clip`,
        message: "Clip name must be a string",
        code: "INVALID_CLIP"
      }), i.speed !== void 0 && (typeof i.speed != "number" || i.speed <= 0) && t.push({
        field: `states.${s}.speed`,
        message: "Speed must be a positive number",
        code: "INVALID_SPEED"
      }));
    }
    return t;
  }
  _resolveAll() {
    const e = super._resolveAll(), t = e.states;
    if (!t) return e;
    const s = this.getAuthored().states;
    for (const i of p) {
      const n = s?.[i], r = t[i];
      if (!n || !r) continue;
      const a = this._resolveSettledRef(n.src);
      a !== void 0 && (r.src = a);
      const c = this._resolveSettledRef(n.clip);
      c !== void 0 && (r.clip = c);
    }
    return e;
  }
  _resolveSettledRef(e) {
    if (typeof e != "string") return;
    const t = y(e);
    if (!t) return;
    const s = this.sceneObject.resolveProperty(t, !0);
    return typeof s == "string" ? s : void 0;
  }
  async applyCommit(e, t) {
    const s = t.states ?? {}, i = this._resolved.states ?? {}, n = i.enter?.src !== s.enter?.src || i.enter?.clip !== s.enter?.clip, r = i.main?.src !== s.main?.src || i.main?.clip !== s.main?.clip, a = i.exit?.src !== s.exit?.src || i.exit?.clip !== s.exit?.clip;
    if (n || r || a) {
      this.stop(), await this._hotReloadGroups(n, r, a), this.playMode && this._hasAnyClip() && this.playSequence();
      return;
    }
    this._applySpeeds();
  }
  async load() {
    l(this.sceneObject.getOrCreateAnimationRoot(), "[AnimationSequence]");
    for (const e of p) {
      const t = this._resolved.states[e];
      d(t?.src) && this._setGroup(e, await this._loadClip(t.src, f[e], t.clip, this._clipTargetFor(e)));
    }
    this._resetLayer(), o.debug(`AnimationSequence: clips ready on ${this.sceneObject.name} (no auto-play)`);
  }
  onAttach() {
    o.debug("[AnimationSequence] attach");
  }
  onPlayModeChanged(e) {
    e ? this.sceneObject.effectiveActive && this.playSequence() : this.stop();
  }
  onEffectiveActiveChanged(e) {
    this.playMode && (e ? this._hasAnyClip() && this.playSequence() : this.stop());
  }
  requestExit() {
    const e = this.getExit();
    if (e.isEmpty) return Promise.resolve();
    const t = e.delay;
    return t <= 0 ? e.play() : new Promise((s) => {
      this._exitDelayResolve = s, this._exitDelayTimer = _(this.scene).after(t * 1e3, () => {
        this._exitDelayTimer = null, this._exitDelayResolve = null, e.play().then(s);
      });
    });
  }
  onDetach() {
    o.debug("[AnimationSequence] detach"), this.stop();
    for (const t of [
      this.enterGroup,
      this.mainGroup,
      this.exitGroup
    ])
      if (t)
        try {
          t.dispose();
        } catch (s) {
          o.warn(`[AnimationSequence] Failed to dispose group "${t.name}": ${String(s)}`);
        }
    this.enterGroup = this.mainGroup = this.exitGroup = null;
    const e = this.sceneObject.animationRoot;
    e && l(e, "[AnimationSequence]"), this._resetLayer();
  }
  stop() {
    this._stopAll(), this._currentState = "idle";
    const e = this.sceneObject.animationRoot;
    e && l(e, "[AnimationSequence]"), this._resetLayer();
  }
  isPlaying() {
    return this._currentState !== "idle";
  }
  getCurrentState() {
    return this._currentState;
  }
  _accessor = null;
  _getAccessor() {
    return this._accessor || (this._accessor = {
      getResolved: (e) => this._resolved.states?.[e],
      setSpeed: (e, t) => this._setStateSpeed(e, t),
      commitState: (e, t) => this._commitState(e, t),
      clearState: (e) => this._clearState(e),
      stopState: (e) => this._stopState(e),
      poseState: (e) => this._poseState(e),
      playState: (e) => this._playState(e),
      getClipNamesForSrc: (e) => this.getClipNamesForSrc(e)
    }), this._accessor;
  }
  getEnter() {
    return new m(this._getAccessor(), "enter");
  }
  getMain() {
    return new m(this._getAccessor(), "main");
  }
  getExit() {
    return new m(this._getAccessor(), "exit");
  }
  _setStateSpeed(e, t) {
    const s = this._resolved.states?.[e];
    if (!s) return 1;
    const i = Math.max(t, 0.01), n = this.getAuthored();
    n.states?.[e] && (n.states[e].speed = i), s.speed = i;
    const r = this._getGroup(e);
    return r && (r.speedRatio = i), i;
  }
  async _commitState(e, t) {
    const s = this.getAuthored().states ?? {}, i = s[e] ?? {};
    await this.commit({ states: {
      ...s,
      [e]: {
        ...i,
        ...t
      }
    } });
  }
  async _clearState(e) {
    const t = { ...this.getAuthored().states };
    delete t[e], await this.commit({ states: t });
  }
  _stopState(e) {
    const t = this._getGroup(e);
    if (this._stopGroup(t), this._currentState === e) {
      this._currentState = "idle";
      const s = this.sceneObject.animationRoot;
      s && l(s, "[AnimationSequence]"), this._resetLayer();
    }
  }
  _poseState(e) {
    const t = this._getGroup(e);
    t && (this._stopAll(t), this._currentState = e, this._poseGroupAtStart(t, this._speedFor(e)));
  }
  _playState(e) {
    switch (e) {
      case "enter":
        return this._playEnter();
      case "main":
        return this._playMain();
      case "exit":
        return this._playExit();
    }
  }
  _getGroup(e) {
    switch (e) {
      case "enter":
        return this.enterGroup;
      case "main":
        return this.mainGroup;
      case "exit":
        return this.exitGroup;
    }
  }
  setGroupsForTest(e) {
    for (const t of p) t in e && this._setGroup(t, e[t] ?? null);
  }
  _setGroup(e, t) {
    switch (e) {
      case "enter":
        this.enterGroup = t;
        break;
      case "main":
        this.mainGroup = t;
        break;
      case "exit":
        this.exitGroup = t;
        break;
    }
  }
  async getClipNamesForSrc(e) {
    return g(e, this.scene, this.resources);
  }
  playSequence() {
    this._clearExitDelayTimer(), this._stopGroup(this.exitGroup), this.enterGroup || this._resetLayer();
    const e = this._resolved.states.enter?.delay ?? 0;
    if (this.enterGroup && e > 0) {
      this._poseState("enter"), this._poseMainUnderEnter(), this._enterDelayTimer = _(this.scene).after(e * 1e3, () => {
        this._enterDelayTimer = null, this._startSequencePlayback();
      });
      return;
    }
    this._startSequencePlayback();
  }
  _poseGroupAtStart(e, t) {
    e.isStarted || e.start(!1, t), e.pause(), e.goToFrame(e.from), e.setWeightForAllAnimatables(1);
  }
  _poseMainUnderEnter() {
    this.mainGroup && this._poseGroupAtStart(this.mainGroup, this._speedFor("main"));
  }
  _resumeMainLoop() {
    this.mainGroup && (this.mainGroup.setWeightForAllAnimatables(1), this.mainGroup.speedRatio = this._speedFor("main"), this.mainGroup.play(!0));
  }
  restoreSteadyState() {
    this._clearExitDelayTimer(), this._stopGroup(this.exitGroup), this._resetLayer(), this.mainGroup?.isPlaying ? this._currentState = "main" : this.mainGroup ? this._playMain() : this._currentState = "idle";
  }
  _startSequencePlayback() {
    const e = !!this.enterGroup, t = !!this.mainGroup;
    if (e && t) {
      o.debug(`[AnimationSequence] Playing enter → main sequence for ${this.sceneObject.name}`), this._stopAll(), this._currentState = "enter";
      const s = this.enterGroup;
      this._poseMainUnderEnter(), this._armGroup(s, "enter"), this._enterEndObserver = s.onAnimationGroupEndObservable.addOnce(() => {
        this._enterEndObserver = null, this._currentState === "enter" && (o.debug(`[AnimationSequence] Enter complete, transitioning to main for ${this.sceneObject.name}`), this._currentState = "main", this._resetLayer(), this._resumeMainLoop());
      }), s.play(!1);
    } else e ? this._playEnter() : t ? this._playMain() : this.exitGroup ? this._currentState = "idle" : o.warn(`[AnimationSequence] No animations available for ${this.sceneObject.name}`);
  }
  _playEnter() {
    return this.enterGroup ? (this._stopAll(this.enterGroup), this._currentState = "enter", this._armGroup(this.enterGroup, "enter"), new Promise((e) => {
      this.enterGroup.onAnimationGroupEndObservable.addOnce(() => {
        this._currentState === "enter" && (this._currentState = "idle"), e();
      }), this.enterGroup.play(!1);
    })) : Promise.resolve();
  }
  _playMain() {
    return this.mainGroup && (this._stopAll(this.mainGroup), this._currentState = "main", this._armGroup(this.mainGroup, "main"), this.mainGroup.start(!0)), Promise.resolve();
  }
  _playExit() {
    if (!this.exitGroup) return Promise.resolve();
    this._clearEnterDelayTimer();
    const e = this._currentState === "enter";
    return this._clearEnterEndObserver(), this._stopGroup(this.enterGroup), e && (this._resetLayer(), this._resumeMainLoop()), this._currentState = "exit", this._armGroup(this.exitGroup, "exit"), new Promise((t) => {
      this.exitGroup.onAnimationGroupEndObservable.addOnce(() => {
        this._currentState === "exit" && (this._currentState = this.mainGroup?.isPlaying ? "main" : "idle", o.debug(`[AnimationSequence] Exit complete for ${this.sceneObject.name}`)), t();
      }), this.exitGroup.play(!1);
    });
  }
  _clipTargetFor(e) {
    return e === "main" ? this.sceneObject.animationRoot || this.sceneObject.transform : this.sceneObject.getOrCreateAnimationLayer();
  }
  _speedFor(e) {
    return this._resolved.states[e]?.speed ?? 1;
  }
  _armGroup(e, t) {
    e.reset(), e.setWeightForAllAnimatables(1), e.speedRatio = this._speedFor(t);
  }
  _stopGroup(e) {
    if (e)
      try {
        e.stop();
      } catch (t) {
        e._scene && o.warn(`[AnimationSequence] Failed to stop group "${e.name}": ${String(t)}`);
      }
  }
  _resetLayer() {
    const e = this.sceneObject.animationLayer;
    e && l(e, "[AnimationSequence]");
  }
  async _hotReloadGroups(e, t, s) {
    this.sceneObject.getOrCreateAnimationRoot();
    const i = this._resolved.states ?? {}, n = {
      enter: e,
      main: t,
      exit: s
    };
    for (const r of p) {
      if (!n[r]) continue;
      const a = this._getGroup(r);
      if (a) try {
        a.dispose();
      } catch (u) {
        o.warn(`[AnimationSequence] Failed to dispose ${r} group: ${String(u)}`);
      }
      this._setGroup(r, null);
      const c = i[r];
      d(c?.src) && this._setGroup(r, await this._loadClip(c.src, f[r], c.clip, this._clipTargetFor(r)));
    }
    o.debug(`[AnimationSequence] Hot-reloaded animation groups for ${this.sceneObject.name}`);
  }
  _hasAnyClip() {
    return !!(this.enterGroup || this.mainGroup || this.exitGroup);
  }
  _applySpeeds() {
    this.enterGroup && (this.enterGroup.speedRatio = this._speedFor("enter")), this.mainGroup && (this.mainGroup.speedRatio = this._speedFor("main")), this.exitGroup && (this.exitGroup.speedRatio = this._speedFor("exit"));
  }
  _clearEnterDelayTimer() {
    this._enterDelayTimer?.(), this._enterDelayTimer = null;
  }
  _clearExitDelayTimer() {
    if (this._exitDelayTimer?.(), this._exitDelayTimer = null, this._exitDelayResolve !== null) {
      const e = this._exitDelayResolve;
      this._exitDelayResolve = null, e();
    }
  }
  _clearEnterEndObserver() {
    this._enterEndObserver !== null && (this.enterGroup?.onAnimationGroupEndObservable.remove(this._enterEndObserver), this._enterEndObserver = null);
  }
  _stopAll(e) {
    this._clearEnterDelayTimer(), this._clearExitDelayTimer(), this._clearEnterEndObserver();
    for (const t of [
      this.enterGroup,
      this.mainGroup,
      this.exitGroup
    ]) t !== e && this._stopGroup(t);
  }
  async _loadClip(e, t, s, i) {
    let n = !1;
    try {
      const r = await this.resources.getOrLoadContainer(e, this.scene);
      if (n = !0, !r.animationGroups.length)
        return o.warn(`AnimationSequence: no groups in ${e}`), null;
      let a;
      if (s) {
        if (a = r.animationGroups.find((h) => h.name === s), !a)
          return o.warn(`AnimationSequence: clip "${s}" not found in ${e}. Available:`, r.animationGroups.map((h) => h.name)), null;
      } else a = r.animationGroups[0];
      const c = i ?? (this.sceneObject.animationRoot || this.sceneObject.transform);
      a.targetedAnimations.some((h) => h.animation.targetProperty === "rotationQuaternion") && G(c);
      const u = new A(t, this.scene);
      for (const h of a.targetedAnimations) u.addTargetedAnimation(h.animation.clone(), c);
      return u;
    } catch (r) {
      return o.error(`AnimationSequence: failed to load ${e}: ${String(r)}`), null;
    } finally {
      n && this.resources.releaseContainer(e);
    }
  }
};
export {
  m as n,
  T as t
};

//# sourceMappingURL=animationsequence-C8TMiBUE.js.map